var exports = {
  "kL": "x2b2fbebb--452521--container",
  "wx": "x2b2fbebb--452521--header",
  "Qs": "x2b2fbebb--452521--content",
};

module.exports = exports;
